export default "__VITE_ASSET__BcBZLL1f__"